import * as React from 'react';
import { LoadOptions } from 'app/types-shared';
import { CodetableMetadata } from '../../types-store';
import { CodeComplexValue } from '../../../shared/codetable/types';
import { CodeSinglePicker } from '../../common';
import { CodetableTranslation } from '../../constants';
import { isDefinedIncludingZero } from 'app/infrastructure/data/number';

import styles from './code-category.scss';
import { manageOptionsButton } from 'app/area/shared/manage-options';

interface CodeCategoryProps {
  breadcrumbs: number[];
  category: CodeComplexValue<number>;
  metadata: CodetableMetadata;
  onChange: (value: CodeComplexValue<number>) => void;
  translation: CodetableTranslation;

  options: {
    [key: string]: {
      fetching: boolean;
      codes: CodeComplexValue<number>[];
    };
  };
  loadOptions: (id: string,
    codetableId: number,
    loadOptionsParams: LoadOptions) => void;
  listCategoryLabel: (translation: CodetableTranslation) => string;
}

export const CodeCategory = (props: CodeCategoryProps) => {

  const { breadcrumbs, metadata, category, options, translation,
    loadOptions, onChange, listCategoryLabel } = props;

  if (!metadata || !metadata.codetableCategory || !isDefinedIncludingZero(metadata.codetableCategory.id)) {
    return null;
  }

  const codeOptions = (options && options.category && options.category.codes || []) as CodeComplexValue<number>[];

  const onLoadOptions = (id: string, loadOptionsParams: LoadOptions) => {
    loadOptions(id, metadata.codetableCategory.id, loadOptionsParams);
  };

  const extraFooterButton = manageOptionsButton(translation.manage_options, metadata.codetableCategory.id, breadcrumbs);

  const label = metadata.codetableCategory.label ??
    (translation && listCategoryLabel ? listCategoryLabel(translation) : translation.category);

  return <CodeSinglePicker
    className={styles.noPadding}
    id="category"
    label={label}
    valueItem={category}

    options={codeOptions}
    fetchingOptions={options && options.category && options.category.fetching}

    translation={translation}
    onLoadOptions={onLoadOptions}
    onChange={onChange}
    searchRequired={metadata.codetableCategory.searchRequired}
    extraFooterButton={extraFooterButton}
  />;
};
